<template>
	<div class='content'>
		<Modal footer-hide v-model="showModal" title="课程详情" :loading="$root.$children[0].modalLoading" width="1243"
			class="my-modal top p-b">
			<div class="table-box template-table">
				<loading :isShow="tableLoading" />
				<Table row-key="id" :columns="columns" :data="tableData" border>
					<template slot-scope="{ row }" slot="homeWorkStatus">
						<div>
							{{ row.homeWorkStatus || '-' }}
						</div>
					</template>
					<template slot-scope="{ row }" slot="grade">
						<div>
							<span v-if="row.grade == 2">不及格</span>
							<span v-else-if="row.grade == 3">不及格</span>
							<span v-else>{{ row.grade || '-' }}</span>
						</div>
					</template>
					<!-- 成绩（空则显示横杠）,3：及格2：不及格 -->
				</Table>
				<Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
					style="text-align: center; margin-top: 20px" />
			</div>
		</Modal>
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {
			showModal: false,
			search: {
				agentId: ''
			}, //查询数据
			tableLoading: false, //表格loading
			tabActive: "1",
			columns: [ //表格字段
				{
					title: "序号",
					align: "center",
					type: "index",
				},
				{
					title: "课程名称",
					key: "name",
					align: "center",
				},
				{
					title: "学习时长",
					key: "trainLength",
					align: "center",
				},
				{
					title: "最后学习时间",
					key: "lastTime",
					align: "center",
				}, {
					title: "作业状态",
					slot: "homeWorkStatus",
					align: "center",
				}, {
					title: "成绩",
					slot: "grade",
					align: "center",
				},
			],
			tableData: [], //表格数据
			total: 0, //表格记录数
			pageSize: 10, //页容量
			pageNum: 1, //当前页
		}
	},
	created() { },
	methods: {
		open(id) {
			if (id) {
				this.search.agentId = id;
			}
			this.searchAjax();
			this.showModal = true;
		},
		getParams() {
			const params = Object.assign({}, this.search);
			return params;
		},
		searchAjax() {
			this.pageNum = 1;
			this.getList();
		}, // 获取列表数据
		getList() {
			const params = this.getParams();
			params.pageNo = this.pageNum;
			params.pageSize = this.pageSize;
			this.tableLoading = true;
			this.$http({
				url: "/buz/staffTrainRecord/read/detail",
				type: "POST",
				data: params
			})
				.then(res => {
					this.tableLoading = false;
					this.tableData = res.data;
					this.total = res.total;
				})
				.catch(e => {
					this.tableLoading = false;
				});
		}
	},
}
</script>
<style lang='scss' scoped>
.template-table {
	margin-top: 10px;
}
</style>
